var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{class:_vm.link_class,attrs:{"to":_vm.to}},[_c('div',{staticClass:"item-wrapper"},[_c('font-awesome-icon',{attrs:{"icon":_vm.icon}}),(_vm.badge)?_c('b-badge',{staticClass:"overlay-badge",attrs:{"variant":"danger"}},[_vm._v(_vm._s(_vm.badge))]):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }